import { Route, Routes } from "react-router-dom";
import Login from "../../pages/vendor/auth/Login";
import Dashboard from "../../pages/vendor/Dashboard";
import Product from "../../pages/vendor/Product";
import Orders from "../../pages/vendor/Order";
import VendorManager from "../../pages/vendor/Vendor/VendorManager";
import MenuPricing from "../../pages/vendor/menu-pricing/MenuPricing";
import ExcelImportProducts from "../../pages/vendor/product/ExcelImportProducts";
import CafeteriaInventory from "../../pages/vendor/cafeteria-inventory/CafeteriaInventory";
import GalleryList from "../../pages/vendor/gallery/GalleryList";
import VendorCompliance from "../../pages/vendor/vendorCompliance/VendorCompliances";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/products" element={<Product />} />
      <Route path="/vendor-managers" element={<VendorManager />} />
      <Route path="/menu-pricing" element={<MenuPricing />} />
      <Route path="/excel-products/:id" element={<ExcelImportProducts />} />
      <Route path="/gallery" element={<GalleryList />} />
      <Route path="/vendor-compliance" element={<VendorCompliance />} />


       <Route path="/cafeteria-inventory" element={<CafeteriaInventory />} />
      
    </Routes>
  );
};
export default AdminRoutes;
